import { render, staticRenderFns } from "./FollowList.vue?vue&type=template&id=6173eecb&scoped=true&"
import script from "./FollowList.vue?vue&type=script&lang=js&"
export * from "./FollowList.vue?vue&type=script&lang=js&"
import style0 from "./FollowList.vue?vue&type=style&index=0&id=6173eecb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173eecb",
  null
  
)

export default component.exports